export const MIXING_CYCLE = 'MIXING CYCLE';
export const MANUAL_CONTROL = 'MANUAL CONTROL';
export const SWITCH_TO_MANUAL_CONTROL = 'SWITCH TO MANUAL';
export const MANUAL_CONTROL_ENUM = {
  HOLD_TO_RUN: 3,
  CUSTOM_VOLUME_MANUAL_CONTROL: 2,
  DEFAULT_VOLUME_MANUAL_CONTROL: 1,
};
